export default "__VITE_ASSET__Cngt9pZ9__"